const VideoCarouselWithCopyIcons = {
  parts: [
    'container',
    'background',
    'backgroundMedia',
    'backgroundOverlay',
    'content',
    'contentHeader',
    'kicker',
    'title',
    'tabsList',
    'mobileSwiper',
    'tab',
    'tabLabel',
    'tabIndicator',
    'tabContent',
    'subheading',
    'description',
    'navigationControls',
    'navButton',
    'navIcon'
  ],
  baseStyle: {
    container: {
      position: 'relative',
      width: 'full',
      overflow: 'hidden',
      bg: 'black',
      aspectRatio: {base: '375/700', md: '16/9'},
    },
    background: {
      position: 'absolute',
      inset: 0,
      width: 'full',
      height: 'full',
      zIndex: 0,
    },
    backgroundMedia: {
      width: 'full',
      height: 'full',
      objectFit: 'cover',
    },
    backgroundOverlay: {
      position: 'absolute',
      inset: 0,
      background:
        'linear-gradient(180deg, rgba(0, 0, 0, 0.72) 8%, rgba(0, 0, 0, 0.56) 48%, rgba(0, 0, 0, 0.84) 100%)',
    },
    content: {
      position: 'relative',
      zIndex: 1,
      maxWidth: '1440px',
      mx: 'auto',
      px: {base: 5, md: 16},
      py: {base: 12, md: 30},
      pb: {base: 25, md: 30},
      color: 'brandColors.primaryBG',
      display: 'flex',
      flexDirection: 'column',
      alignItems: {base: 'center', lg: 'stretch'},
      gap: {base: 10, md: 12},
      height: {base: 'full', md: 'auto'},
    },
    contentHeader: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: 2,
    },
    kicker: {
      textTransform: 'uppercase',
      letterSpacing: 'wider',
      fontFamily: 'heading',
      fontSize: {base: 'xs', md: 'sm'},
      fontWeight: 'medium',
      textAlign: 'center',
      color: 'brandColors.primaryBG',
    },
    title: {
      fontFamily: 'heading',
      fontWeight: 'medium',
      fontSize: {base: '3xl', md: '5xl'},
      lineHeight: '120%',
      textAlign: 'center',
      maxW: {base: 'full', md: '3xl'},
      mx: 'auto',
    },
    tabsList: {
      display: {base: 'none', md: 'flex'},
      justifyContent: 'center',
      alignItems: 'center',
      gap: 5,
      flexWrap: 'wrap',
    },
    mobileSwiper: {
      width: 'full',
      mx: 'auto',
      sx: {
        '& .swiper-wrapper': {
          alignItems: 'stretch',
        },
        '& .swiper-slide': {
          width: 30,
        },
      },
    },
    tab: {
      position: 'relative',
      cursor: 'pointer',
      p: 0,
      minW: {base: 30, md: '160px'},
      h: 11,
      opacity: 0.7,
      transition: 'opacity 0.3s ease',
      display: 'flex',
      gap: 1,
      justifyContent: 'flex-start',
      alignItems: 'center',
      borderTop: '1px solid white',
      _hover: {
        opacity: 1,
      },
      sx: {
        '&[data-active="true"]': {
          opacity: 1,
        },
      },
    },
    tabLabel: {
      fontFamily: 'heading',
      fontSize: {base: 'xs', md: 'md'},
      fontWeight: 'medium',
      letterSpacing: 'widest',
      color: 'brandColors.primaryBG',
      sx: {
        '&[data-active="true"]': {
          fontWeight: 'bold',
        },
      },
    },
    tabIndicator: {
      position: 'absolute',
      top: '-1px',
      left: 0,
      right: 0,
      height: '3px',
      bg: 'brandColors.primaryBG',
    },
    tabContent: {
      display: 'flex',
      flexDirection: {base: 'column', lg: 'row'},
      gap: {base: 4, lg: 10},
      alignItems: {base: 'stretch', lg: 'flex-start'},
      pt: {base: 0, md: 10},
      maxW: {base: 'none', lg: '840px'},
      width: 'full',
      marginX: 'auto',
      marginTop: {base: 'auto', md: 0},
    },
    subheading: {
      fontFamily: 'heading',
      fontWeight: 'medium',
      fontSize: {base: '2xl', md: '4xl'},
      lineHeight: '120%',
      letterSpacing: '-0.24px',
      flex: {base: 'none', lg: '0 0 calc(50% - 20px)'},
    },
    description: {
      fontFamily: 'body',
      fontSize: {base: 'sm', md: 'lg'},
      lineHeight: '150%',
      letterSpacing: '-0.08px',
      color: 'brandColors.primaryBG',
      flex: {base: 'none', lg: '0 0 calc(50% - 20px)'},
    },
    navigationControls: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      gap: 5,
      flexDirection: 'row',
      width: 17.5,
      position: 'absolute',
      bottom: {base: 10, lg: 20},
      left: 0,
      right: 0,
      mx: 'auto',
      zIndex: 1,
    },
    navButton: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      cursor: 'pointer',
    },
    navIcon: {
      width: 2.75,
      height: 5,
      color: 'white',
      flexShrink: 0,
    },
  },
};

export default VideoCarouselWithCopyIcons;
